import { useEffect, useState } from 'react';

import {
  DEFAULT_DASHBOARD_PREFERENCES,
  readDashboardPreferences,
  writeDashboardPreferences,
} from './dashboard-preferences';
import type { DashboardPreferences } from './dashboard.types';

interface DashboardPreferencesState {
  userId?: string;
  preferences: DashboardPreferences;
  hasStorageError: boolean;
}

export function useDashboardPreferences(userId?: string) {
  const [state, setState] = useState<DashboardPreferencesState>({
    preferences: DEFAULT_DASHBOARD_PREFERENCES,
    hasStorageError: false,
  });

  useEffect(() => {
    setState({
      userId,
      preferences: readDashboardPreferences(userId),
      hasStorageError: false,
    });
  }, [userId]);

  const savePreferences = (preferences: DashboardPreferences): boolean => {
    const didSave = writeDashboardPreferences(userId, preferences);

    setState({
      userId,
      preferences: didSave ? preferences : state.preferences,
      hasStorageError: !didSave,
    });

    return didSave;
  };

  return {
    preferences: state.preferences,
    isReady: Boolean(userId) && state.userId === userId,
    hasStorageError: state.hasStorageError,
    savePreferences,
  };
}
